import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Company } from '../dto/Company';
import { PpState } from '../component/base/pp.component';

/**
 * Service responsible for holding portfolio performance data.
 */
@Injectable({
  providedIn: 'root',
})
export class PortfolioPerformanceService {
  private selectedCompany$: BehaviorSubject<Company> = new BehaviorSubject(undefined);
  private openCreateRoundModal$: BehaviorSubject<boolean> = new BehaviorSubject(undefined);
  private ppState$: BehaviorSubject<PpState> = new BehaviorSubject(PpState.LOADING_PPS);
  private refreshOrgCompanies$: BehaviorSubject<void> = new BehaviorSubject(null);

  setSelectedCompany(company: Company): void {
    this.selectedCompany$.next(company);
  }

  get selectedCompany(): BehaviorSubject<Company> {
    return this.selectedCompany$;
  }

  setRefreshOrgCompanies(): void {
    this.refreshOrgCompanies$.next();
  }

  refreshOrgCompanies(): Observable<void> {
    return this.refreshOrgCompanies$.asObservable();
  }

  setPpState(ppState: PpState): void {
    this.ppState$.next(ppState);
  }

  ppState(): BehaviorSubject<PpState> {
    return this.ppState$;
  }

  get openCreateRoundModal(): Observable<boolean> {
    return this.openCreateRoundModal$.asObservable();
  }

  setOpenCreateRoundModal(value: boolean): void {
    this.openCreateRoundModal$.next(value);
  }
}
